import { ONE_MINUTE_IN_MILLIS } from "./timeConstants";

export const convertMillisToMinutes = (timeSpentInMillis: number) =>
  timeSpentInMillis / ONE_MINUTE_IN_MILLIS;
